<template>
    <div class="new-chat-wrapper">
        <div class="chat-header">
            <div class="header-btn-wrapper">
                <div style="right:0" class="header-btn" @click="close">
                    <BaseIcon class="clickable button-wrapper" name="times" size="1x" />
                </div>
            </div>
        </div>
        <div class="new-chat-container">
            <div v-if="loading()">
                <Spinner />
            </div>
            <div v-else-if="!loading() && data().length">
                <div v-for="item in data()" :key="item.id">
                    <NewChatListItem :data="item" />
                </div>
            </div>
            <div v-else>
                <div class="chat-no-live-notice">
                    No users are online at the moment. Please come back later.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Spinner from '../builders/Spinner';
import NewChatListItem from './NewChatListItem';
export default {
    name: 'NewChat',
    components: { NewChatListItem, Spinner },
    props: {
        schoolId: Number,
    },
    data() {
        return {
            inbox: {},
        };
    },
    computed: {
        availableChatUsers() {
            return this.$interfaces.communication.chat.availability.id
                .org_id(this.schoolId)
                .get({ reactive: true });
        },
    },
    methods: {
        close() {
            this.$emit('close');
        },
        data() {
            return this.availableChatUsers.data;
        },
        loading() {
            return this.availableChatUsers.loading;
        },
    },
    mounted() {},
};
</script>

<style scoped>
.new-chat-wrapper {
    box-shadow: var(--shadow);
    position: fixed;
    right: 100px;
    bottom: 20px;
    height: 400px;
    width: 300px;
    z-index: 100;
    background-color: white;
    border-radius: 5px;
}
.chat-header {
    padding: 5px;
    height: 40px;
    background-color: #848a97;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
}
.header-btn-wrapper {
    /*height:10px;*/
}
.header-btn {
    position: absolute;
    color: white;
}
.chat-no-live-notice {
    padding: 15px;
    text-align: center;
}
.new-chat-container {
    position: absolute;
    width: 100%;
    height: 360px;
    overflow-y: scroll;
}
.button-wrapper {
    padding: 3px 10px !important;
}
</style>
